import { Component, Directive, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
export class TdDialogTitleDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'td-dialog-title'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdDialogTitleDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdDialogTitleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDialogTitleDirective.ctorParameters;
}

export class TdDialogContentDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'td-dialog-content'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdDialogContentDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdDialogContentDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDialogContentDirective.ctorParameters;
}

export class TdDialogActionsDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'td-dialog-actions'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdDialogActionsDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdDialogActionsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDialogActionsDirective.ctorParameters;
}

export class TdDialogComponent implements AfterContentInit {

   dialogTitle: QueryList<TdDialogTitleDirective>;
   dialogContent: QueryList<TdDialogContentDirective>;
   dialogActions: QueryList<TdDialogActionsDirective>;
/**
 * @return {?}
 */
ngAfterContentInit(): void {
    if (this.dialogTitle.length > 1) {
      throw new Error('Duplicate td-dialog-title component at in td-dialog.');
    }
    if (this.dialogContent.length > 1) {
      throw new Error('Duplicate td-dialog-content component at in td-dialog.');
    }
    if (this.dialogActions.length > 1) {
      throw new Error('Duplicate td-dialog-actions component at in td-dialog.');
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css' ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dialogTitle': [{ type: ContentChildren, args: [TdDialogTitleDirective, ] },],
'dialogContent': [{ type: ContentChildren, args: [TdDialogContentDirective, ] },],
'dialogActions': [{ type: ContentChildren, args: [TdDialogActionsDirective, ] },],
};
}

function TdDialogComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdDialogComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDialogComponent.ctorParameters;
/** @type {?} */
TdDialogComponent.propDecorators;
/** @type {?} */
TdDialogComponent.prototype.dialogTitle;
/** @type {?} */
TdDialogComponent.prototype.dialogContent;
/** @type {?} */
TdDialogComponent.prototype.dialogActions;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
